import React from "react";
import CtaButton from "@/components/CtaButton";
import { MagicLetterBoxLink } from "@/components/funnel/MagicLetterBoxLink";
import useSEO from "@/hooks/useSEO";
import { STATIC_ROUTE_META } from "@/utils/routeMetadata";

const About = () => {
  useSEO(STATIC_ROUTE_META["/about"]);
  
  return (
    <>
      <section className="py-16 md:py-24 bg-elfGreen-light">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">About Elf Letter Bot</h1>
          <p className="text-lg md:text-xl mb-8 max-w-3xl mx-auto">
            Free resources and personalized letters for family Christmas traditions
          </p>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-3xl mx-auto">
            <h2 className="text-3xl font-bold mb-6">Our Story</h2>
            <p className="mb-6">
              Elf Letter Bot is a free resource site for families who want a little more wonder in their Christmas traditions. Explore ideas, use our holiday tools, and create personalized elf letters with three free printable PDF deliveries per email address.
            </p>
            <p className="mb-6">
              The letters are AI-assisted starting points. A parent or caregiver reviews each letter and decides whether it is ready to share. Families make the final call about what fits their home.
            </p>
            <p className="mb-12">
              Our goal is simple: make it easier to keep a warm, personal tradition going when December gets busy.
            </p>

            <h2 className="text-3xl font-bold mb-6">Two ways to keep the magic going</h2>
            <div className="grid gap-6 md:grid-cols-2 mb-12">
              <div className="rounded-2xl bg-elfGreen-light p-6">
                <h3 className="text-2xl font-bold mb-3 text-elfGreen-ink">Elf Letter Bot</h3>
                <p className="mb-6">
                  Start here for free holiday resources and three personalized PDF letter deliveries per email address.
                </p>
                <CtaButton
                  text="Try the free generator"
                  href="/elf-letter-generator?utm_source=about&utm_medium=product-story&utm_campaign=free-generator"
                  variant="secondary"
                  className="w-full"
                />
              </div>
              <div className="rounded-2xl bg-elfPink-light p-6">
                <h3 className="text-2xl font-bold mb-3 text-elfRed-ink">The Magic Letter Box</h3>
                <p className="mb-6">
                  Try five letters with the parent trial, then choose Family for $15/year with unlimited letters, premium templates, up to six children, saved history, and email delivery.
                </p>
                <MagicLetterBoxLink
                  source="about"
                  campaign="family-membership"
                  className="inline-block w-full rounded-xl bg-elfRed-ink px-6 py-3 text-center font-semibold text-white shadow-md transition-colors duration-300 hover:bg-[#892638]"
                >
                  Explore Family membership
                </MagicLetterBoxLink>
              </div>
            </div>

            <h2 id="donnie" className="scroll-mt-24 text-3xl font-bold mb-6">Meet Donnie</h2>
            <p className="mb-6">
              Donnie is the founder of Elf Letter Bot and The Magic Letter Box. He created both products to give families a simple way to add a personal note of magic to the season.
            </p>
            <p className="mb-12">
              Elf Letter Bot is the free starting point. The Magic Letter Box is the expanded paid experience for families who want more letters and more ways to save and reuse their holiday details.
            </p>

            <h2 id="editorial" className="scroll-mt-24 text-3xl font-bold mb-6">Editorial notes</h2>
            <p className="mb-6">
              “Elf Letter Team” is the editorial contributor label used for resources published without a named individual byline. Named contributors keep the credit shown on their articles.
            </p>
            <p>
              Our AI-assisted letters are meant to be reviewed by a parent or caregiver before they are shared. Read each article and idea in the context of your own family, traditions, and judgment.
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
